import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      username: null,
      display_name: null,
      access_token: null,
      refresh_token: null,
      id_token: null
    }
  },
  mutations: {
    user_init(state) {
      console.log("USER INIT");
      var user_username = this._vm.$localStorage.get("user_username");
      var user_display_name = this._vm.$localStorage.get("user_display_name");
      var user_access_token = this._vm.$localStorage.get("user_access_token");
      var user_refresh_token = this._vm.$localStorage.get("user_refresh_token");
      var user_id_token = this._vm.$localStorage.get("user_id_token");
      if (user_display_name) {
        console.log("User display name:", user_display_name);
        state.user.username = user_username;
        state.user.display_name = user_display_name;
        state.user.access_token = user_access_token;
        state.user.refresh_token = user_refresh_token;
        state.user.id_token = user_id_token;
      }
    },
    clear_user_data(state) {
      state.user.username = null;
      state.user.display_name = null;
      state.user.access_token = null;
      state.user.id_token = null;
      state.user.refresh_token = null;
      this._vm.$localStorage.remove("user_username");
      this._vm.$localStorage.remove("user_display_name");
      this._vm.$localStorage.remove("user_access_token");
      this._vm.$localStorage.remove("user_refresh_token");
      this._vm.$localStorage.remove("user_id_token");
    },
    user_login(state, data) {
      state.user.username = data.email;
      state.user.display_name = data.given_name;
      state.user.access_token = data.access_token;
      state.user.id_token = data.id_token;
      state.user.refresh_token = data.refresh_token;

      this._vm.$localStorage.set("user_username", this.state.user.username);
      this._vm.$localStorage.set(
        "user_display_name",
        this.state.user.display_name
      );
      this._vm.$localStorage.set(
        "user_access_token",
        this.state.user.access_token
      );
      this._vm.$localStorage.set("user_id_token", this.state.user.id_token);
      this._vm.$localStorage.set(
        "user_refresh_token",
        this.state.user.refresh_token
      );
    }
  },
  actions: {
    user_session_ended({ commit }) {
      commit("clear_user_data");

      Vue.$toast.open({
        message: `Sesja wygasła. Zaloguj się ponownie.`,
        queue: true,
        position: "top-right",
        type: "success"
      });
    },
    user_logout({ commit, state }) {
      let username = state.user.display_name;
      commit("clear_user_data");

      Vue.$toast.open({
        message: `${username} dziękujemy że byłeś z nami.`,
        queue: true,
        position: "top-right",
        type: "success"
      });
      Vue.$toast.open({
        message:
          "Wszystkie wprowadzone informacje zostały bezpiecznie zapisane.",
        queue: true,
        position: "top-right",
        type: "success"
      });
    }
  },
  modules: {}
});
